(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"));
	else if(typeof define === 'function' && define.amd)
		define(["d3"], factory);
	else if(typeof exports === 'object')
		exports["fornac"] = factory(require("d3"));
	else
		root["fornac"] = factory(root["d3"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__893__) => {
return 